// @flow

import * as React from 'react';
import Relay from 'react-relay/classic';

import { Section, SectionHeading } from './shared';

type Props = {
  auditEvent: {
    actor?: {
      name?: string,
      type?: string,
      uuid?: string,
      node?: {
        name: string,
        avatar: {
          url: string
        }
      }
    }
  }
};

class AuditLogActorSection extends React.PureComponent<Props> {
  render() {
    const { actor } = this.props.auditEvent;

    if (!actor) {
      return null;
    }

    return (
      <Section>
        <SectionHeading className="m0 mb2">
          Actor
        </SectionHeading>
        <dl className="m0">
          {this.renderActorType(actor)}
          {this.renderActorName(actor)}
          {this.renderActorUuid(actor)}
        </dl>
      </Section>
    );
  }

  renderActorType({ type }) {
    return [
      <dt className="mt1 dark-gray" key="type-title">
        Actor Type
      </dt>,
      <dd className="ml0 monospace" key="type-definition">
        {type}
      </dd>
    ];
  }

  renderActorName({ name, node }) {
    const renderedName = (node && node.name) || name;

    if (renderedName) {
      return [
        <dt className="mt1 dark-gray" key="name-title">
          Actor Name
        </dt>,
        <dd className="ml0" key="name-definition">
          {renderedName}
        </dd>
      ];
    }
  }

  renderActorUuid({ uuid }) {
    if (uuid) {
      return [
        <dt className="mt1 dark-gray" key="uuid-title">
          Actor UUID
        </dt>,
        <dd className="ml0" key="uuid-definition">
          {uuid}
        </dd>
      ];
    }
  }
}

export default Relay.createContainer(AuditLogActorSection, {
  fragments: {
    auditEvent: () => Relay.QL`
      fragment on AuditEvent {
        actor {
          name
          type
          uuid
          node {
            ...on User {
              name
              avatar {
                url
              }
            }
          }
        }
      }
    `
  }
});
